import React from 'react';

const Minus = ({ color = '#000', ...props }) => (
	<svg width="24" height="24" viewBox="0 0 24 24" {...props}>
		<g fill="none" fillRule="evenodd">
			<path d="M0 24h24V0H0z" />
			<path
				d="M20 13v-1.5c-5.328.34-10.672.34-16 0V13a125.62 125.62 0 0 1 16 0z"
				fill={color}
				fillRule="nonzero"
			/>
		</g>
	</svg>
);

export default Minus;
